import { render, staticRenderFns } from "./Vermogensregie.vue?vue&type=template&id=0a94fcbc&scoped=true"
import script from "./Vermogensregie.vue?vue&type=script&lang=js"
export * from "./Vermogensregie.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a94fcbc",
  null
  
)

export default component.exports